import defaultConfig from './default';

const config = {
    ...defaultConfig,
    environment: 'production',
    apiURL: "https://api.sinbi.com/",
    websocketURL: "wss://api.sinbi.com"
};

export default config;